export type IconType = 'regular' | 'solid'

export const iconNames = [
  'archive',
  'arrow-alt-left',
  'arrow-alt-right',
  'arrow-alt-to-left',
  'arrow-alt-to-right',
  'arrows-h',
  'ban',
  'bars-sort',
  'bell',
  'bell-slash',
  'briefcase',
  'calendar-alt',
  'caret-down',
  'caret-right',
  'check',
  'check-circle',
  'check-square',
  'chevron-double-left',
  'chevron-double-right',
  'chevron-down',
  'chevron-left',
  'chevron-right',
  'chevron-up',
  'circle',
  'circle-user',
  'clipboard-list',
  'clock',
  'cog',
  'columns',
  'comment',
  'comments',
  'compress-alt',
  'convert-pdf',
  'dollar-sign',
  'download',
  'edit',
  'ellipsis-h',
  'ellipsis-v',
  'envelope',
  'envelope-open',
  'exclamation-triangle',
  'exclamation-circle',
  'expand-arrows',
  'external-link-alt',
  'eye',
  'eye-slash',
  'file',
  'file-alt',
  'file-archive',
  'file-export',
  'filter',
  'flag',
  'flask',
  'folder',
  'folder-open',
  'folder-tree',
  'frown',
  'hand-paper',
  'hand-point-right',
  'highlighter',
  'history',
  'hourglass-start',
  'i-cursor',
  'inbox-out',
  'info',
  'info-circle',
  'level-up',
  'link',
  'list-alt',
  'listui',
  'lock',
  'lock-open',
  'mapmarker-alt',
  'menu',
  'minus',
  'minus-circle',
  'multi-folder',
  'multi-folder-open',
  'ocr',
  'paperclip',
  'pause',
  'pause-circle',
  'pencil-alt',
  'phone',
  'play',
  'play-circle',
  'plus',
  'print',
  'redo',
  'save',
  'search',
  'search-plus',
  'share-square',
  'sitemap',
  'sort',
  'sort-down',
  'sort-up',
  'spinner',
  'square',
  'star',
  'sub-folder',
  'sync',
  'tachometer-alt',
  'tag',
  'tags',
  'tasks',
  'text-slash',
  'th-large',
  'Thumbtack',
  'times',
  'times-circle',
  'tools',
  'trash-alt',
  'university',
  'upload',
  'user',
  'users',
  'wrench'
] as const

export type IconName = (typeof iconNames)[number]

export function isValidIconName(name: string): name is IconName {
  return iconNames.includes(name as IconName)
}
